module.exports = __webpack_public_path__ + "img/vn_vn.332005f5.png";